import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getBreadcrumbConfig, generateBreadcrumbSchema } from '../config/breadcrumbConfig';

const DynamicBreadcrumb = ({ additionalData = {} }) => {
  const location = useLocation();
  const params = useParams();
  
  // Get config on every render
  const dynamicParams = { ...params, ...additionalData };
  const config = getBreadcrumbConfig(location.pathname, dynamicParams);
  
  // Don't render anything if no data or homepage
  if (!config || location.pathname === '/') {
    return null;
  }

  const { breadcrumb } = config;
  const breadcrumbSchema = generateBreadcrumbSchema(breadcrumb);
  
  return (
    <>
      {/* JSON-LD for dynamic pages */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema, null, 2)}
      </script>
    </>
  );
};

export default DynamicBreadcrumb;